module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAA0UlEQVQoka2SrQoCQRSFv5UtgkGQzf5skH0Lg3XRbtq+wbTFajIZ7BYfQMGiyeoTDBMmWAVBEDQqA44Mq+IOeMrcOXM/zh243mQ2X1Jcd2CQpclVEz7Qc4DXBjSw0Q04foE0sANGtmnD2yxN+kXilRQ1IPYL9ObBJrAHgo+wkmIIVC3rHLaj6bPWb0F+bFu6oW7dD4CBX37JdWxbf4MvrrD954UpwnbUKJq80luWpcnGNdnLG0qKLtABKl+YGGi9wUoKvX5j52QlRRk4Afr8LeABsEstq+My06wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/specializations/leagueoflegends/top.png
// module id = 9xft
// module chunks = 35